module.exports = __webpack_public_path__ + "img/eu.ee7f4712.svg";